import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ClubhouseRouter } from './lobby/Clubhouse';
import './styles/tokens.css';
import './styles/app.css';
import './theme/fonts.css';
import './styles/scene.css';
import './styles/views.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClubhouseRouter />
  </StrictMode>,
);
